import { useThemeVersion } from '@raisin/components-lib';
import { useMarkets as useMarketsV1 } from './v1/useMarkets';
import { useMarkets as useMarketsV2 } from './v2/useMarkets';
export const useMarkets = () => {
    const theme = useThemeVersion();
    if (theme === 'v2') {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        return useMarketsV2();
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return useMarketsV1();
};
//# sourceMappingURL=useMarkets.js.map